import { ChangeEvent, FC, FormEvent, useState } from 'react'
import { InputFile } from './input-file'
import Loading from '../../../components/Loading'
import { DocumentsType } from './interface'

interface CNPJCardProps {
    handleSubmit(document: DocumentsType): Promise<{ error: boolean }>
    setIsOpen(value: boolean): void
}

export const CNPJCard: FC<CNPJCardProps> = ({ handleSubmit, setIsOpen }) => {
    const [documents, setDocuments] = useState<DocumentsType>({
        documentGroup: 'cartao-cnpj',
        files: [],
        numFilesRequired: 1,
    })
    const [isLoading, setIsLoading] = useState(false)

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        setIsLoading(true)
        const result = await handleSubmit(documents)
        setIsLoading(false)

        if (result.error === false) {
            setIsOpen(false)
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]

        if (!file) return

        const newDocument = {
            docType: event.target.name, // Use o atributo 'name' para armazenar o tipo do documento
            file,
        }

        const filesFiltred = documents.files.filter(
            (item) => item.docType !== newDocument.docType
        )

        setDocuments((prevState) => ({
            ...prevState,
            files: [...filesFiltred, newDocument],
        }))
    }

    const cnpjCardDocument = documents.files.find(
        (document) => document.docType === 'cartao-cnpj'
    )

    if (isLoading) {
        return (
            <div className="flex items-center justify-center w-full">
                <Loading />
            </div>
        )
    }

    return (
        <form
            onSubmit={onSubmit}
            className="flex flex-col justify-between gap-4 mt-6"
        >
            <div className="flex-1 px-6">
                <InputFile
                    label="Cartão CNPJ"
                    document={cnpjCardDocument}
                    handleFileChange={handleFileChange}
                    name="cartao-cnpj"
                />
                <div className="flex flex-col gap-8 mt-8">
                    <div className="bg-amber-300/80 rounded-md p-4 shadow-sm">
                        <ul className="list-disc list-inside tracking-tight">
                            <li>
                                O cartão CNPJ deve estar{' '}
                                <span className="text-amber-800 font-semibold">
                                    aberto
                                </span>
                                , em boa qualidade, boa iluminação e com dados
                                legíveis.
                            </li>
                            <li>
                                Você deve enviar uma foto do{' '}
                                <span className="text-amber-800 font-semibold">
                                    cartão CNPJ original
                                </span>{' '}
                                ou o{' '}
                                <span className="text-amber-800 font-semibold">
                                    cartão CNPJ digital
                                </span>
                                .
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-end gap-2 pb-6 px-6 w-full">
                <button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    className="border border-black py-1 px-2 rounded-md h-8 flex items-center justify-center hover:bg-gray-400/20 transition ease-in duration-100 focus:ring-red-500 focus:ring-offset-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="py-1 px-2 flex items-center justify-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md h-8"
                >
                    Confirmar
                </button>
            </div>
        </form>
    )
}
